import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  Slide,
  DialogContent,
  GlobalStyles,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PaymentsIcon from "@mui/icons-material/Payments";
import SecurityIcon from "@mui/icons-material/Security";
import ShareIcon from "@mui/icons-material/Share";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import { People, Warning } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { queryInviteInfo, queryInviteInfoByCode } from "../api/modules/payment";
import { showMessage } from "../utils";
import { removeToken } from "../utils/auth";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share";
import { Helmet } from "react-helmet";
import { isInApp } from "../utils/environment"; // 引入环境判断函数
import { QRCodeSVG } from "qrcode.react";
import InviteStats from "../components/referral/InviteStats";
import WebReferralBanner from "../components/referral/WebReferralBanner";
import html2canvas from "html2canvas";
import { width } from "@mui/system";
import TopBar from '../components/TopBar';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import ShareDialog from '../components/ShareDialog';
import { getShareUrl, shareTitle, shareToApp, handleCopyLink } from '../utils/share';

// 添加滑动动画
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ReferralProgram = () => {
  const navigate = useNavigate();
  const [inviteInfo, setInviteInfo] = useState(null);
  const [username, setUsername] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openShareDialog, setOpenShareDialog] = useState(false);
  const qrCodeRef = useRef();
  const [openQRCodeDialog, setOpenQRCodeDialog] = useState(false);
  const qrDialogRef = useRef();
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [isQRDialogReady, setIsQRDialogReady] = useState(false);

  // 获取 inviteCode，优先用 inviteInfo，否则用 localStorage
  const inviteCode = inviteInfo?.inviteCode || localStorage.getItem('inviteCode') || '';
  const shareUrl = getShareUrl();
  const isShareUrlReady = !!inviteCode;

  // 使用 useRef 防止 StrictMode 重复调用
  const hasFetchedRef = useRef(false);

  // 获取提现记录
  useEffect(() => {
    if (!hasFetchedRef.current) {
      fetchInviteInfo();
      hasFetchedRef.current = true;
    }
  }, []);

  // 监听 QR 弹窗状态，确保内容渲染完成后启用保存按钮
  useEffect(() => {
    if (openQRCodeDialog) {
      // 弹窗打开时，如果没有用户名且有邀请码，立即获取用户名
      if (!username && inviteCode) {
        fetchInviteInfoByCode(inviteCode);
      }

      // 弹窗打开后，等待更长时间确保内容完全渲染
      const timer = setTimeout(() => {
        setIsQRDialogReady(true);
      }, 1500); // 增加到 1.5 秒，确保所有内容都渲染完成

      return () => clearTimeout(timer);
    } else {
      setIsQRDialogReady(false);
    }
  }, [openQRCodeDialog, username, inviteCode]);

  useEffect(() => {
    if (inviteInfo?.inviteCode) {
      localStorage.setItem('inviteCode', inviteInfo.inviteCode);
      fetchInviteInfoByCode(inviteInfo?.inviteCode);
    }
  }, [inviteInfo?.inviteCode]);

  const fetchInviteInfoByCode = (code) => {
    queryInviteInfoByCode({ inviteCode }, (rst) => {
      const { code, data, msg } = rst || {}; // 确保rst存在
      if (code === 200 && data) {
        setUsername(data);
      } else {
        showMessage(msg, "error"); // 处理msg不存在的情况
      }
    });
  };

  const fetchInviteInfo = () => {
    queryInviteInfo({}, (rst) => {
      const { code, data, msg } = rst || {}; // 确保rst存在
      if (code === 200 && data) {
        setInviteInfo(data);
      } else {
        showMessage(msg, "error"); // 处理msg不存在的情况
      }
    });
  };

  const referralData = [
    { range: "1-10", commission: "$500" },
    { range: "11-100", commission: "$5,000" },
    { range: "101-500", commission: "$25,000" },
    { range: "501-1000", commission: "$50,000" },
    { range: "1000+", commission: "$50,000+" },
  ];

  const referralDataBusiness = [
    { range: "1-10", commission: "$1,000" },
    { range: "11-100", commission: "$10,000" },
    { range: "101-500", commission: "$50,000" },
    { range: "501-1000", commission: "$100,000" },
    { range: "1000+", commission: "$100,000+" },
  ];

  const steps = [
    {
      title: "Join the Program",
      description: "Sign up and get approved to become an ambassador",
    },
    {
      title: "Share Your Link",
      description:
        "Share your unique referral link with friends, followers, and on social media",
    },
    {
      title: "Earn Big - No Limits",
      description: "Get $50 for each new user who spends $50 or more",
    },
  ];

  const rules = [
    {
      icon: <ShareIcon />,
      title: "Invite Your Friends",
      description:
        "Share it with your network and help them save their first time!",
    },
    {
      icon: <CardGiftcardIcon />,
      title: "Your Friends Save $$$",
      description: "Each friend you invite gets a special welcome bonus",
    },
    {
      icon: <MonetizationOnIcon />,
      title: "You Earn Unlimited Rewards",
      description: "Get $50 for each new user who spends $50 or more",
    },
  ];

  const services = [
    {
      icon: <SupportAgentIcon />,
      title: "Dedicated Ambassador Support",
      description: "You'll get 24/7 support – We Got Your Back!",
    },
    {
      icon: <PaymentsIcon />,
      title: "Fast Payment System",
      description: "Get Paid Weekly – No Minimum Payout",
    },
    {
      icon: <SecurityIcon />,
      title: "No Fees, No Strings",
      description: "Keep 100% of what you earn",
    },
  ];

  const questions = [
    {
      title: "Who can join the program?",
      content:
        "Anyone can join the program. All you need is a valid email address and a valid phone number.",
    },
    {
      title: "Referral Payout",
      content:
        "A referral is a new customer who signs up for uTaxes using your unique referral link. The referred customer must meet eligibility criteria, such as being a new user and subscribing to a paid uTaxes service.",
    },
    {
      title: "What is a referral?",
      content:
        "Yes! When your referral signs up using your link, they receive an exclusive discount on their first-year subscription to uTaxes. The specific discount percentage or dollar amount may vary based on ongoing promotions.",
    },
    {
      title: "Does my referral receive any benefits?",
      content:
        'A "closed deal" occurs when a referred customer successfully signs up for a paid uTaxes subscription and completes their first payment. Only closed deals qualify for referral payouts.',
    },
    {
      title: 'What is a "closed deal"?',
      content: (
        <span>
          A "Closed Deal" occurs when your referred client meets the following
          criteria:
          <br />
          1. Successful Registration and Payment: The referred client registers
          for a paid uTaxes subscription through your unique referral link and
          completes the initial payment.
          <br />
          2. Submission of a Valid Tax Return: The referred client uses uTaxes
          to submit a legitimate tax return to the IRS, such as Form 1040 for
          individuals or Form 1120 for corporations.
          <br />
          To ensure the integrity and uniqueness of each referral, the following
          conditions must be met:
          <br />
          ● Valid Taxpayer Identification: The referred client must provide a
          valid Social Security Number (SSN) or Employer Identification Number
          (EIN), which must not duplicate any existing records in the uTaxes
          system.
          <br />
          ● Unique Filing Entity: Each taxpayer (individual or business entity)
          is permitted only one uTaxes account. Duplicate accounts, test
          accounts, or accounts that do not submit an official tax return are
          ineligible for referral rewards.
          <br />
          Please note that only referrals meeting all the above criteria are
          eligible for referral rewards.
        </span>
      ),
    },
  ];

  // 添加检测设备类型的函数
  const handleDownload = () => {
    // 定义正则表达式常量，避免重复创建
    const ANDROID_REGEX = /Android/i;
    const IPAD_REGEX = /iPad/i;
    const IPOD_IPHONE_REGEX = /iPod|iPhone/i;
    const MAC_OS_REGEX = /Mac OS X/;

    const userAgent = window.navigator.userAgent;
    // 检查是否为 Android 设备
    const isAndroid = ANDROID_REGEX.test(userAgent);
    // 检查是否为 iPad 设备
    const isIPad = !isAndroid && IPAD_REGEX.test(userAgent);
    // 检查是否为 iPhone 或 iPod 设备
    const isIPhone = !isAndroid && IPOD_IPHONE_REGEX.test(userAgent);
    // 检查是否为 Mac 设备
    const isMac = MAC_OS_REGEX.test(userAgent);
    // 检查是否为 iOS 设备
    const isIOS = isIPhone || isIPad;
    // 检查是否为 iOS 或 Mac 设备
    const isIOSMac = isIOS || isMac;

    const downloadUrl = isIOSMac
      ? "https://apps.apple.com/us/app/utaxes/id6740635190?pid=Ambassador"
      : "https://play.google.com/store/apps/details?id=com.utaxes.api&hl=en&referrer=utm_source%3DAmbassador";

    window.open(downloadUrl, "_blank");
  };

  const handleShareClick = () => {
    setOpenShareDialog(true);
  };

  const handleCloseShare = () => {
    setOpenShareDialog(false);
  };

  const handleCopyInviteCode = () => {
    if (isInApp()) {
      if (window.flutterApp) {
        const copyData = {
          type: "Copy",
          text: inviteInfo?.inviteCode,
        };
        window.flutterApp.postMessage(JSON.stringify(copyData));
      }
      return;
    }
    navigator?.clipboard
      ?.writeText(inviteInfo?.inviteCode)
      .then(() => {
        showMessage("Invite code copied to clipboard!", "success");
      })
      .catch((err) => {
        showMessage("Failed to copy invite code", "error");
      });
  };

  const handleDownloadQRCode = () => {
    setOpenQRCodeDialog(true);
  };


  const handleSaveQRCodeImage = async () => {
    try {
      // 检查元素是否存在
      const element = qrDialogRef.current;

      if (!element) {
        showMessage('Error: Content not found, please reopen the dialog', 'error');
        return;
      }

      if (element.offsetWidth === 0 || element.offsetHeight === 0) {
        showMessage('Error: Content size is abnormal, please wait for content to load', 'error');
        return;
      }

      // 等待内容完全渲染
      await new Promise(resolve => setTimeout(resolve, 500));

      // 执行截图
      const canvas = await html2canvas(element, {
        backgroundColor: "#F7F9FB",
        useCORS: true,
        allowTaint: true,
        scale: 1,
        logging: false,
        width: element.offsetWidth,
        height: element.offsetHeight
      });

      if (canvas.width === 0 || canvas.height === 0) {
        throw new Error('Empty screenshot result');
      }

      // 生成图片数据
      const dataURL = canvas.toDataURL("image/png", 0.95);

      if (!dataURL || dataURL === 'data:,') {
        throw new Error('Unable to generate image data');
      }

      // APP内打开的兼容处理
      if (isInApp()) {
        if (window.flutterApp) {
          const saveData = {
            type: "SaveImage",
            data: dataURL,
          };
          window.flutterApp.postMessage(JSON.stringify(saveData));
          showMessage("Invite card saved successfully!", "success");
        }
        return;
      }

      // 浏览器环境：创建下载
      const link = document.createElement("a");
      link.download = "utaxes-invite-card.png";
      link.href = dataURL;
      link.style.display = 'none';

      // 触发下载
      document.body.appendChild(link);
      link.click();

      // 清理
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);

      showMessage("Invite card saved successfully!", "success");

    } catch (error) {
      showMessage(`Save failed: ${error.message}. Please try refreshing the page or use browser screenshot feature.`, 'error');
    }
  };

  const handleUserMenuOpen = (event) => setUserMenuAnchor(event.currentTarget);
  const handleUserMenuClose = () => setUserMenuAnchor(null);

  return (
    <Box>
      <TopBar
        isLogin={true}
        onCouponClick={() => navigate('/campaigns/invitations/tax-declaration')}
        onAvatarClick={handleUserMenuOpen}
        userMenuAnchor={userMenuAnchor}
        onUserMenuClose={handleUserMenuClose}
        navigate={navigate}
        onLogout={() => {
          removeToken();
          showMessage("Logout successfully", "success");
          setTimeout(() => {
            navigate("/login");
          }, 1500);
          handleUserMenuClose();
        }}
        onShareClick={() => setOpenShareDialog(true)}
        shareUrl={shareUrl}
        shareTitle={shareTitle}
        shareToApp={shareToApp}
        handleCopyLink={handleCopyLink}
      />
       {/* Header */}
       <Box
          sx={{
            mt: { xs: '56px', md: '64px' },
            width: '100%',
            // background: '#18155a',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* 比例容器，保持 1200x628 的比例 */}
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              maxWidth: '1200px',
              mx: 'auto',
              '&:before': {
                content: '""',
                display: 'block',
                paddingTop: '66.6666%', // 1536:1024  1024/1536 = 66.6666%
              },
            }}
          >
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/images/banner-2.jpg`}
              alt="Header background"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover', // 如果你想完整展示图片用 contain
              }}
            />
          </Box>
        </Box>
      <Box>
        <Container
          sx={{
            maxWidth: "1200px !important",
            px: { xs: 2, md: 3 },
            mx: "auto",
            position: "relative",
            zIndex: 1,
            bgcolor: "#F8FAFC",
            borderRadius: "12px",
            pt: 3,
            pb: 3,
          }}
        >

          <Typography
            sx={{
              fontSize: "28px",
              fontWeight: 700,
              color: "#000",
              mb: 3,
              px: 0,
            }}
          >
            Rewards Dashboard
          </Typography>
          {/* Rewards Section - 统一展示 */}
          <Box sx={{}}>
            {/* 使用InviteStats组件 */}
            <InviteStats
              earnings={inviteInfo?.rewardAmount || "0.00"}
              clients={inviteInfo?.rewardCount || 0}
            />

            {/* 邀请客户卡片 */}
            <Box
              sx={{
                p: 2,
                bgcolor: "white",
                borderRadius: 2,
                boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                mb: 4,
              }}
            >
              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 700,
                  color: "#000000",
                  mb: 4,
                }}
              >
                Invite Clients
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  gap: 4,
                  maxWidth: '100%',
                }}
              >
                {/* 左侧: 邀请码和链接 */}
                <Box sx={{ flex: 1, maxWidth: '400px !important'}}>
                  <Typography
                    sx={{
                      color: "#6B7280",
                      fontSize: "14px",
                      fontWeight: 600,
                      mb: 1.5,
                      textTransform: "uppercase",
                      width: '100%',
                      textAlign: { xs: 'left', md: 'center' },
                    }}
                  >
                    INVITE CODE
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 4,
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1,
                        bgcolor: "#F3F4F6",
                        py: 2,
                        px: 3,
                        borderRadius: 2,
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      {inviteInfo?.inviteCode}
                    </Box>
                    <IconButton
                      onClick={handleCopyInviteCode}
                      sx={{
                        ml: 1,
                        bgcolor: "white",
                        border: "1px solid #E5E7EB",
                        borderRadius: 2,
                        p: 1,
                      }}
                    >
                      <ContentCopyIcon sx={{ color: "#000000" }} />
                    </IconButton>
                  </Box>

                  <Typography
                    sx={{
                      color: "#6B7280",
                      fontSize: "14px",
                      fontWeight: 600,
                      mb: 1.5,
                      textTransform: "uppercase",
                    }}
                  >
                    INVITE LINK
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1,
                        bgcolor: "#F3F4F6",
                        py: 2,
                        px: 3,
                        borderRadius: 2,
                        fontSize: "14px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {isShareUrlReady ? shareUrl : 'Loading...'}
                    </Box>
                    <IconButton
                      onClick={() => handleCopyLink(shareUrl)}
                      sx={{
                        ml: 1,
                        bgcolor: "white",
                        border: "1px solid #E5E7EB",
                        borderRadius: 2,
                        p: 1,
                      }}
                      disabled={!isShareUrlReady}
                    >
                      <ContentCopyIcon sx={{ color: "#000000" }} />
                    </IconButton>
                  </Box>
                </Box>

                {/* 右侧: 二维码 */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#6B7280",
                      fontSize: "14px",
                      fontWeight: 600,
                      mb: 1.5,
                      alignSelf: { xs: "flex-start", md: "center" },
                      textTransform: "uppercase",
                      width: { md: "100%" },
                      textAlign: { xs: "left", md: "center" }
                    }}
                  >
                    INVITE QR CODE
                  </Typography>

                  <Box
                    sx={{
                      border: "1px solid #E5E7EB",
                      p: 3,
                      borderRadius: 2,
                      width: "fit-content",
                      mb: 2,
                    }}
                    ref={qrCodeRef}
                  >
                    <QRCodeSVG
                      value={shareUrl}
                      size={180}
                      level="H"
                      includeMargin={false}
                    />
                  </Box>

                  <Button
                    variant="contained"
                    onClick={handleDownloadQRCode}
                    startIcon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    }
                    sx={{
                      bgcolor: "#000000",
                      color: "white",
                      textTransform: "none",
                      borderRadius: 6,
                      px: 3,
                      "&:hover": {
                        bgcolor: "#333333",
                      },
                    }}
                  >
                    Download QR Code
                  </Button>
                </Box>
              </Box>
            </Box>

            {/* Copy Link Input - 现在被邀请客户卡片替代 */}
          </Box>
          {/* Invite Buttons */}
          <Box
            sx={{
              px: { xs: 0, md: 0 },
              display: "flex",
              gap: 2,
              mb: 3,
              mt: { md: 2 }, // PC 端添加上边距
            }}
          >
            <Button
              variant="outlined"
              fullWidth
              onClick={handleShareClick}
              sx={{
                borderColor: "gray",
                color: "black",
                fontSize: "17px",
                textTransform: "uppercase",
                borderRadius: 2,
                fontWeight: 600,
                padding: "10px",
                "&:hover": {
                  borderColor: "gray",
                  bgcolor: "rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              SHARE
            </Button>
          </Box>
          <Box sx={{ mb: 3 }}>
            {/* Commission Amount Box */}

            <Box
              sx={{
                border: "1px solid #E5E7EB",
                borderRadius: 2,
                p: 2,
                mb: 2,
                bgcolor: "white",
              }}
            >
              {/* Gradient Motivation Text */}
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  background:
                    "linear-gradient(101deg, #7123DF 0%, rgba(254, 46, 185, 0.7) 42.57%, #FF8486 70.27%, #FF9F38 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textAlign: "center",
                  mb: 2,
                }}
              >
                The more <b>you refer</b>, the more <b>you earn!</b>
              </Typography>

              {/* Steps */}
              {[
                {
                  title: "Invite friends, family — anyone!",
                  description:
                    "Share your unique referral link with your network",
                },
                {
                  title: "Share your link on social media",
                  description: "LinkedIn, Facebook, WhatsApp, TikTok, and more",
                },
                {
                  title: "Every referral = real cash",
                  description:
                    "We'll send you a check by mail for each successful referral",
                },
                {
                  title: "Earn up to $10,000+",
                  description: "Just by inviting friends to join our platform",
                },
              ].map((item, index) => (
                <Box key={index} sx={{ display: "flex", mb: 2 }}>
                  <Box
                    sx={{
                      minWidth: 28,
                      height: 28,
                      borderRadius: "50%",
                      backgroundColor: "#F3F4F6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      mr: 2,
                    }}
                  >
                    {index + 1}
                  </Box>
                  <Box>
                    <Typography
                      sx={{ fontWeight: 600, fontSize: "15px", mb: 0.5 }}
                    >
                      {item.title}
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "#6B7280" }}>
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
          {/* 新增的税务卡片部分 */}
          <Box sx={{ px: { xs: 0, md: 0 }, mb: 3 }}>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                color: "#333",
                mb: 3,
              }}
            >
              Invite & Earn
            </Typography>

            {/* 税务卡片容器 */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                mt: 3,
                mb: 3,
                width: '100%',
                maxWidth: 1200,
                mx: 'auto',
              }}
            >
              {/* 卡片1 */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  bgcolor: '#F8FAFF',
                  boxShadow: '0 2px 12px 0 rgba(49, 80, 180, 0.04)',
                  p: 1,
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <RocketLaunchOutlinedIcon sx={{ color: '#3887FE', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography fontWeight={700} fontSize={18} color="#031B4E">
                    Start & Register Your Business
                  </Typography>
                  <Typography fontSize={15} color="#6B7280" mt={0.5}>
                    Form an LLC, S Corp, or C Corp. Get your EIN, licenses, and permits — all in one place.
                  </Typography>
                </Box>
              </Box>
              {/* 卡片2 */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  bgcolor: '#F8FAFF',
                  boxShadow: '0 2px 12px 0 rgba(49, 80, 180, 0.04)',
                  p: 1,
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <AccountBalanceWalletOutlinedIcon sx={{ color: '#3887FE', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography fontWeight={700} fontSize={18} color="#031B4E">
                    File Taxes & Manage Finances
                  </Typography>
                  <Typography fontSize={15} color="#6B7280" mt={0.5}>
                    Handle 1040, 1099, sales tax, and payroll. Track expenses and run payroll with ease.
                  </Typography>
                </Box>
              </Box>
              {/* 卡片3 */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  bgcolor: '#F8FAFF',
                  boxShadow: '0 2px 12px 0 rgba(49, 80, 180, 0.04)',
                  p: 1,
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <SupportAgentOutlinedIcon sx={{ color: '#3887FE', fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography fontWeight={700} fontSize={18} color="#031B4E">
                    CFO Support & Compliance
                  </Typography>
                  <Typography fontSize={15} color="#6B7280" mt={0.5}>
                    Access fractional CFO services, plan your finances, and stay fully compliant year-round.
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* 规则列表部分 */}
            <Box
              sx={{
                bgcolor: "#F8FAFC",
                borderRadius: "8px",
                p: 3,
                border: '1px solid transparent',
                borderImage: "linear-gradient(0deg, #E2E8F0, #E2E8F0) 1",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Box
                  component="img"
                  src={require("../assets/images/right-icon.png")}
                  alt="uTaxes"
                  sx={{
                    width: 20,
                    height: 20,
                    mr: 2,
                  }}
                />
                <Typography
                  sx={{
                    color: "#64748B",
                    fontSize: "15px",
                    lineHeight: 1.5,
                    fontWeight: 400,
                    fontFamily: "Roboto",
                  }}
                >
                  Referrals must complete paid tax filing through your unique link
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Box
                  component="img"
                  src={require("../assets/images/right-icon.png")}
                  alt="uTaxes"
                  sx={{
                    width: 20,
                    height: 20,
                    mr: 2,
                  }}
                />
                <Typography
                  sx={{
                    color: "#64748B",
                    fontSize: "15px",
                    lineHeight: 1.5,
                    fontWeight: 400,
                    fontFamily: "Roboto",
                  }}
                >
                  Available for all U.S. federal and state tax returns
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Box
                  component="img"
                  src={require("../assets/images/right-icon.png")}
                  alt="uTaxes"
                  sx={{
                    width: 20,
                    height: 20,
                    mr: 2,
                  }}
                />
                <Typography
                  sx={{
                    color: "#64748B",
                    fontSize: "15px",
                    lineHeight: 1.5,
                    fontWeight: 400,
                    fontFamily: "Roboto",
                  }}
                >
                  Rewards are issued after the referred user completes a paid
                  filing
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  component="img"
                  src={require("../assets/images/eorr-icon.png")}
                  alt="uTaxes"
                  sx={{
                    width: 20,
                    height: 20,
                    mr: 2,
                  }}
                />
                <Typography
                  sx={{
                    color: "#64748B",
                    fontSize: "15px",
                    lineHeight: 1.5,
                    fontWeight: 400,
                    fontFamily: "Roboto",
                  }}
                >
                  Not valid for free filings, existing users, or untracked
                  sign-ups
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Referral Table */}
          <Box sx={{ px: { xs: 0, md: 0 }, mb: 3 }}>
            <TableContainer
              component={Paper}
              sx={{
                mb: 2,
                boxShadow: "none",
                "& .MuiTable-root": {
                  borderCollapse: "separate",
                  borderSpacing: "0 8px",
                },
              }}
            >
              <Table>
                <TableHead>
                  <TableRow >
                    <TableCell
                      sx={{
                        border: "none",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#333333",
                        padding: "8px 16px",
                      }}
                    >
                      Referral Reward for Business
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        border: "none",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#333333",
                        padding: "8px 16px",
                      }}
                    >
                      Commission
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {referralDataBusiness.map((row) => (
                    <TableRow
                      key={row.range}
                      sx={{
                        backgroundColor: "#F9FAFB",
                        "& td": { border: "none" },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          color: "#374151",
                          padding: "12px 16px",
                          fontWeight: 400,
                        }}
                      >
                        {row.range}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          fontSize: "14px",
                          fontWeight: 900,
                          color: "#059669",
                          padding: "12px 16px",
                        }}
                      >
                        {row.commission}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          {/* Referral Table */}
          <Box sx={{ px: { xs: 0, md: 0 }, mb: 3 }}>
            <TableContainer
              component={Paper}
              sx={{
                mb: 2,
                boxShadow: "none",
                "& .MuiTable-root": {
                  borderCollapse: "separate",
                  borderSpacing: "0 8px",
                },
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        border: "none",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#333333",
                        padding: "8px 16px",
                      }}
                    >
                      Referral Reward for Individual
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        border: "none",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#333333",
                        padding: "8px 16px",
                      }}
                    >
                      Commission
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {referralData.map((row) => (
                    <TableRow
                      key={row.range}
                      sx={{
                        backgroundColor: "#F9FAFB",
                        "& td": { border: "none" },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          color: "#374151",
                          padding: "12px 16px",
                          fontWeight: 400,
                        }}
                      >
                        {row.range}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          fontSize: "14px",
                          fontWeight: 900,
                          color: "#059669",
                          padding: "12px 16px",
                        }}
                      >
                        {row.commission}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Description Text */}
            <Typography
              sx={{
                fontSize: "12px",
                color: "#000000",
                lineHeight: "20px",
                fontWeight: 400,
                px: 2,
              }}
            >
              Provide valid contact information of the referred client. After the
              referral is valid, incentives will be granted based on the scale of
              the referred client.
            </Typography>
          </Box>
          {/* How it works */}
          <Box sx={{ px: { xs: 0, md: 0 }, mb: 4 }}>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 700,
                color: "#1F2329",
                mb: 2,
              }}
            >
              How it works
            </Typography>

            {steps.map((step, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 2,
                  mb: 2,
                  p: 2,
                  backgroundColor: "#F9FAFB",
                  borderRadius: 2,
                }}
              >
                {/* Number Circle */}
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    backgroundColor: "#2563EB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    mt: 0.5,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "white",
                      lineHeight: 1,
                    }}
                  >
                    {index + 1}
                  </Typography>
                </Box>

                {/* Content */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 900,
                      color: "#111827",
                      mb: 0.5,
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#6B7280",
                      lineHeight: "20px",
                      fontWeight: 400,
                    }}
                  >
                    {step.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Rules */}
          <Box sx={{ px: { xs: 0, md: 0 }, mb: 4 }}>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 700,
                color: "#1F2329",
                mb: 2,
              }}
            >
              Rules
            </Typography>

            {rules.map((rule, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 2,
                  mb: 2,
                  p: 2,
                  backgroundColor: "#F8F9FA",
                  borderRadius: 2,
                }}
              >
                {/* Icon Circle */}
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: "#F9FAFB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box
                    sx={{
                      color: "#0052CC",
                      "& svg": {
                        fontSize: 24,
                      },
                    }}
                  >
                    {rule.icon}
                  </Box>
                </Box>

                {/* Content */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 900,
                      color: "#111827",
                      mb: 0.5,
                    }}
                  >
                    {rule.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#6B7280",
                      lineHeight: "20px",
                      fontWeight: 400,
                    }}
                  >
                    {rule.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Our Service */}
          <Box sx={{ px: { xs: 0, md: 0 }, mb: 4 }}>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 700,
                color: "#1F2329",
                mb: 2,
              }}
            >
              Our Service
            </Typography>

            {services.map((service, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 2,
                  mb: 2,
                  p: 2,
                  backgroundColor: "#F9FAFB",
                  borderRadius: 2,
                }}
              >
                {/* Icon Circle */}
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: "#E6F7FF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box
                    sx={{
                      color: "#0052CC",
                      "& svg": {
                        fontSize: 24,
                      },
                    }}
                  >
                    {service.icon}
                  </Box>
                </Box>

                {/* Content */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 900,
                      color: "#111827",
                      mb: 0.5,
                    }}
                  >
                    {service.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#6B7280",
                      lineHeight: "20px",
                      fontWeight: 400,
                    }}
                  >
                    {service.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {/* FAQ */}
          <Box sx={{ px: { xs: 0, md: 0 }, mb: 4 }}>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#333333",
                mb: 2,
              }}
            >
              FAQ
            </Typography>

            {questions.map((question, index) => (
              <Accordion
                key={index}
                sx={{
                  "&:before": { display: "none" },
                  boxShadow: "none",
                  backgroundColor: "#F8F9FA",
                  mb: 1,
                  "&.Mui-expanded": {
                    mb: 1,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<KeyboardArrowDownIcon sx={{ color: "#666666" }} />}
                  sx={{
                    minHeight: 48,
                    "& .MuiAccordionSummary-content": {
                      margin: "12px 0",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#000000",
                    }}
                  >
                    {question.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#666666",
                      lineHeight: "20px",
                    }}
                  >
                    {question.content}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Container>
        <Typography
          sx={{
            fontFamily: {
              xs: "Roboto", // 移动端样式
              md: "Roboto", // PC端样式
            },
            fontWeight: 400,
            fontSize: {
              xs: "10px", // 移动端字体大小
              md: "14px", // PC端字体大小
            },
            lineHeight: "17px",
            letterSpacing: "0%",
            textAlign: "center",
            verticalAlign: "middle",
            mt: 2,
            mb: 2,
          }}
        >
          uTaxes reserves the right to decide the eligible users for this promotion.
        </Typography>
        {/* Footer - 仅在非App环境显示 */}
        {!isInApp() && (
          <>
            {/* 预留底部空间 */}
            <Box sx={{ height: { xs: "80px", md: "100px" } }} />
            {/* 固定定位的footer */}
            <Box
              sx={{
                borderTop: "1px solid #EAECF0",
                backgroundColor: "#080808",
                height: { xs: "60px", md: "80px" },
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
              }}
            >
              <Container
                sx={{
                  height: "100%",
                  maxWidth: { xs: "1200px", md: "1200px" },
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: { xs: 3, md: 6 },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="img"
                    src={require("../assets/images/logo-bottom.png")}
                    alt="uTaxes"
                    sx={{
                      width: 50,
                      height: 50,
                      marginRight: 1,
                    }}
                  />
                  <Box sx={{ color: "white" }}>
                    <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
                      uTaxes
                    </Typography>
                    <Typography sx={{ fontSize: "12px" }}>
                      Love, Peace of Mind
                    </Typography>
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  onClick={handleDownload}
                  sx={{
                    backgroundColor: "#18c641",
                    color: "white",
                    borderRadius: 5,
                    fontSize: "13px",
                    fontWeight: 500,
                    padding: "10px 20px",
                    "&:hover": {
                      backgroundColor: "#45a049",
                    },
                  }}
                >
                  JOIN
                </Button>
              </Container>
            </Box>
          </>
        )}
      </Box>

      {/* 新的分享弹框 */}
      <ShareDialog
        open={openShareDialog}
        onClose={handleCloseShare}
        shareUrl={shareUrl}
        shareTitle={shareTitle}
        shareToApp={shareToApp}
        handleCopyLink={handleCopyLink}
      />

      {/* 在JSX中添加弹窗 */}
      <Dialog
        open={openQRCodeDialog}
        onClose={() => setOpenQRCodeDialog(false)}
        PaperProps={{
          sx: {
            bgcolor: "#fff",
            borderRadius: "12px",
            m: 2,
            mt: "20px",
            maxWidth: "95vw",
          },
        }}
      >
        <DialogContent
          sx={{
            p: 0,
            bgcolor: '#F7F9FB',
            borderRadius: '8px',
            overflow: 'hidden',
            minWidth: 0,
            maxWidth: 420,
            width: '100%',
          }}
        >
          {/* 专门用于截图的容器 - 包含所有要保存的内容 */}
          <Box
            ref={qrDialogRef}
            sx={{
              width: '100%',
              maxWidth: 420,
              mx: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 0,
              bgcolor: '#F7F9FB', // 确保背景色一致
              borderRadius: '8px', // 添加圆角
              overflow: 'hidden', // 确保圆角效果
            }}
          >
            {/* 顶部Banner */}
            <Box
              sx={{
                width: '100%',
                maxWidth: '100%',
                p: 2,
                background: 'linear-gradient(90deg, #3887FE 0%, #7B61FF 100%)',
                backgroundImage: 'linear-gradient(90deg, #3887FE 0%, #7B61FF 100%)',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                boxSizing: 'border-box',
                minHeight: '80px',
              }}
              data-gradient="top-banner"
            >
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  bgcolor: '#fff',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: 24,
                  color: '#3887FE',
                  boxShadow: '0 2px 8px rgba(49,135,254,0.10)',
                }}
              >
                {username ? username.slice(0, 2) : 'uT'}
              </Box>
              <Box sx={{ ml: 1 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 20, color: '#fff', mb: 0.5 }}>
                  {username || 'uTaxes'}
                </Typography>
                <Typography sx={{ fontSize: 16, color: '#E0E7FF', fontWeight: 400 }}>
                  You're Invited to Try uTaxes
                </Typography>
              </Box>
            </Box>

            {/* 三大卡片 */}
            <Box
              sx={{
                p: 1,
                pt: 1,
                pb: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                bgcolor: '#F7F9FB',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
              }}
            >
              {/* 卡片1 */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  bgcolor: '#fff',
                  borderRadius: '18px',
                  boxShadow: '0 2px 12px 0 rgba(49, 80, 180, 0.04)',
                  p: 1,
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    bgcolor: '#E6F0FF',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <RocketLaunchOutlinedIcon sx={{ color: '#3887FE', fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography fontWeight={700} fontSize={15} color="#031B4E">
                    Start & Register Your Business
                  </Typography>
                  <Typography fontSize={12} color="#6B7280" mt={0.5}>
                    Form an LLC, S Corp, or C Corp. Get your EIN, licenses, and permits — all in one place.
                  </Typography>
                </Box>
              </Box>
              {/* 卡片2 */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  bgcolor: '#fff',
                  borderRadius: '18px',
                  boxShadow: '0 2px 12px 0 rgba(49, 80, 180, 0.04)',
                  p: 1,
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    bgcolor: '#E6F0FF',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <AccountBalanceWalletOutlinedIcon sx={{ color: '#3887FE', fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography fontWeight={700} fontSize={15} color="#031B4E">
                    File Taxes & Manage Finances
                  </Typography>
                  <Typography fontSize={12} color="#6B7280" mt={0.5}>
                    Handle 1040, 1099, sales tax, and payroll. Track expenses and run payroll with ease.
                  </Typography>
                </Box>
              </Box>
              {/* 卡片3 */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  bgcolor: '#fff',
                  borderRadius: '18px',
                  boxShadow: '0 2px 12px 0 rgba(49, 80, 180, 0.04)',
                  p: 1,
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    bgcolor: '#E6F0FF',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <SupportAgentOutlinedIcon sx={{ color: '#3887FE', fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography fontWeight={700} fontSize={15} color="#031B4E">
                    CFO Support & Compliance
                  </Typography>
                  <Typography fontSize={12} color="#6B7280" mt={0.5}>
                    Access fractional CFO services, plan your finances, and stay fully compliant year-round.
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* 底部横向渐变区 */}
            <Box
              sx={{
                width: '100%',
                maxWidth: '100%',
                p: 0,
                background: 'linear-gradient(90deg, #3887FE 0%, #7B61FF 60%, #A13B3B 100%)',
                backgroundImage: 'linear-gradient(90deg, #3887FE 0%, #7B61FF 60%, #A13B3B 100%)',
                display: 'flex',
                flexDirection: 'row', // 始终横向
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 160,
                gap: { xs: 2, sm: 2 },
                px: { xs: 2, sm: 2 },
                boxSizing: 'border-box',
                flexWrap: 'nowrap',
                mx: 'auto',
              }}
              data-gradient="bottom-banner"
            >
              {/* 二维码 */}
              <Box
                sx={{
                  bgcolor: '#fff',
                  borderRadius: '16px',
                  boxShadow: '0 2px 8px rgba(79,140,255,0.08)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: { xs: 140, sm: 140 },
                  height: { xs: 140, sm: 140 },
                  minWidth: 100,
                  minHeight: 100,
                  position: 'relative',
                  mx: 0,
                  my: 0,
                  maxWidth: '45vw',
                  flexShrink: 0,
                }}
              >
                <QRCodeSVG
                  value={shareUrl}
                  size={120}
                  level="H"
                  includeMargin={false}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%,-50%)',
                    width: 24,
                    height: 24,
                    bgcolor: '#1976d2',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 700,
                    pointerEvents: 'none',
                  }}
                >
                  H
                </Box>
              </Box>
              {/* 右侧LOGO+品牌名+文案 */}
              <Box
                sx={{
                  color: '#fff',
                  ml: { xs: 0, sm: 0 },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: { xs: 'flex-start', sm: 'flex-start' },
                  flex: 1,
                  minWidth: 0,
                  maxWidth: '55vw',
                  textAlign: 'left',
                  overflow: 'hidden',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <img
                    src={require('../assets/images/none-text-logo.png')}
                    alt="uTaxes"
                    style={{ width: 30, height: 30, marginRight: 10 }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                  <Typography sx={{ fontWeight: 700, fontSize: 32, color: '#000', letterSpacing: 1 }}>
                    uTaxes
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: 10, color: '#E0E7FF', mb: 1, fontWeight: 500 }}>
                  Love, Peace of Mind
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#fff', fontWeight: 400 }}>
                  Please search <b>"uTaxes"</b> in the app store to download the app.
                </Typography>
              </Box>
            </Box>
          </Box>
          {/* Save QR Code 按钮 - 在 ref 范围外 */}
          <Box sx={{ px: { xs: 3, sm: 4 }, pb: 3, pt: 2, bgcolor: '#F7F9FB', width: '100%', maxWidth: 420, mx: 'auto', boxSizing: 'border-box' }}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                mt: 1,
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: 16,
                bgcolor: isQRDialogReady ? '#3887FE' : '#CCCCCC',
                color: '#fff',
                boxShadow: '0 2px 8px rgba(49,135,254,0.10)',
                textTransform: 'uppercase',
                '&:hover': {
                  bgcolor: isQRDialogReady ? '#2563EB' : '#CCCCCC'
                },
                '&:disabled': {
                  bgcolor: '#CCCCCC',
                  color: '#999999'
                }
              }}
              onClick={() => {
                if (isQRDialogReady) {
                  handleSaveQRCodeImage();
                }
              }}
              disabled={!isQRDialogReady}
            >
              {isQRDialogReady ? 'Save Invite Card' : 'Loading...'}
            </Button>


          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ReferralProgram;
